export default __webpack_public_path__ + "static/media/paresseuxmaison.cf59bb14.png";